import { DeviceHelper } from "./device";

export const Pulse = {
  push: event => {
    event.event_category = (event || {}).event_category
      ? event.event_category
      : "";
    event.utm_campaign = (event || {}).platform
      ? event.platform
      : DeviceHelper.identify();
    event.event = (event || {}).event ? event.event : "custom_event";
    event.vertical_name = 'oauth';
    event.screenName = (event || {}).screenName
      ? event.screenName
      : ((document || {}).location || {}).pathname;
    window &&
      window.paytm &&
      window.paytm.analytics &&
      window.paytm.analytics.addEvent(event);
  },
};
